import { Link } from 'react-router-dom';
import { useVault } from '../session/useVault';
import { VaultErrorSection } from '../session/VaultErrorSection';
import { Loading } from '../shell/Loading';
import { DeskPage } from './DeskPage';

/** The web's home: the desk, drawn once the vault is open. */
export function DeskRoute() {
  const { state, reload } = useVault();
  if (state.status === 'disconnected') {
    return (
      <section className="placeholder">
        <h1>Not connected</h1>
        <p>
          <Link to="/connect">Connect this browser</Link> to read your vault.
        </p>
      </section>
    );
  }
  if (state.status === 'error') return <VaultErrorSection state={state} reload={reload} />;
  if (state.status === 'loading') return <Loading title="Opening the vault…" />;
  return <DeskPage />;
}
